export const DEFAULT_VENDOR_TYPE = 'Cafeteria Counter';
export const VENDOR_TYPE = 'restaurant';
export const DELIVERY_CHARGE = 'delivery_charge';
export const DELIVERY_NEVER_FREE = -1;
export const PICK_UP_TYPE_DELIVERY = 'delivery';
export const SLOT_BOOKING = 'slot_booking';
export const SPACE_BOOKING = 'space_booking';
export const SUBSCRIPTION_BOOKING = 'subscription';
export const FREE = 'FREE';
export const VENDOR_TYPE_RESTAURANT = 'restaurant';
export const CARD = 'CARD';
export const UPI = 'UPI';
export const CHARGE_TYPE = 'container_charge';
export const CONTAINER_CHARGE_TYPE = 'container_charge';
export const NET_BANKING = 'NET_BANKING';
export const NB = 'NB';
export const PHONEPE = 'PHONEPE';
export const OLAPOSTPAID = 'OLAPOSTPAID';
export const MOBIKWIK = 'MOBIKWIK';
export const PAYTM = 'PAYTM';
export const PAY_LATER = 'PAY_LATER';
export const PAYMENT_DIRECT_PAYTM_WALLET = 'PD_WALLET';
export const PAYMENT_DIRECT_PAYTM_POSTPAID = 'PD_POSTPAID_WALLET';
export const PAYMENT_UPI_COLLECT = 'PaytmUPICollect';
export const PAYTM_MINI_APP = 'PAYTM_MINI_APP';
export const VENDING_MACHINE = 'vending_machine';
export const SODEXO_FOOD_CARD = 'SODEXO_FOOD_CARD';
export const AMEX = 'AMEX';
/// WALLETS
export const WALLET = 'WALLET';
export const INTERNAL = 'internal';
export const HUNGERBOX_WALLETS = 'HUNGERBOX_WALLETS';
export const MORE_NETBANKING_OPTIONS = 'more_netbanking_options';
export const OTHER_BANKS = 'Other Banks';

export const NORMAL_WALLET = 'normal_wallet';
export const ADD_WALLET = 'add_wallet';

export const DEFAULT_CANCELLED_MESSAGE = 'The food counter is unable to place your order';

export const JUSPAY_UPI_COLLECT = 'JusPayUPICollect';
export const JUSPAY = 'JUSPAY';
export const SIMPL = 'SIMPL';
export const UPI_COLLECT = 'UPI_COLLECT';

export const SODEXO_CODE = 'sodexo';
export const ZETA_CODE = 'zeta';

// TEXTS
export const LAZY_PAY_ALREADY_LINKED = 'lazypay is already linked with your Hungerbox account.';
export const WALLET_LINKED_SUCCESSFULLY = 'Wallet linked successfully';

export const SLOT_BOOKING_TITLE_INACTIVE = 'Got food from home?';
export const SLOT_BOOKING_SUBTITLE_INACTIVE = 'Book your entry slot for cafeteria here';
export const SLOT_BOOKING_TITLE_ACTIVE = 'Entry booking confirmed';
export const SLOT_BOOKING_SUBTITLE_ACTIVE = 'You can enter the cafe at: ';
export const SLOT_BOOKING_TITLE_CONFIRMED = 'You can enter the cafe now';
export const SLOT_BOOKING_SUBTITLE_CONFIRMED = 'Scan QR code at entry';
export const SLOT_BOOKING_BUTTON_ACTIVE = 'Enter Cafe';
export const SLOT_BOOKING_BUTTON_INACTIVE = 'Book';
export const SLOT_BOOKING_ERROR =
  'To maintain cafe congestion, please book another cafe entry slot';

export const CANNOT_ADD_TO_CART = 'Cannot add to cart';
export const OUT_OF_STOCK = 'Out of Stock';
export const UNABLE_TO_BOOK = 'Unable to book';

export const CANNOT_ADD_TO_CART_MESSAGE =
  'As per food policy, you are not allowed to add anymore free meals. Please select some other item from the menu.';
export const CONGESTION_MESSAGE =
  'To maintain cafe congestion, please book another cafe entry slot in the next occasion.';

export const CANNOT_REMOVE_FROM_CART =
  'This item contains customisations. Please change the quantity from the cart.';

export const REMOVE_ITEMS_FROM_LIST = 'Please remove the food items from the list above.';

export const CANNOT_SELECT_EXTERNAL_PAYMENT =
  "Can't select external payment if you have sufficient balance in Wallet.";

export const CANCELLED_OTP_LINKING = 'You cancelled the otp linking';
export const HB_WALLET_COMPULSORY =
  "Can't select another payment method if you have sufficient balance in your wallet.";

export const REORDER = 'reorder';
export const CAR_GET_CLEARED = 'Your cart will get cleared';
export const OTHER_ITEMS_IN_CART_MESSAGE =
  'You have items from another food counter in your cart. Do you wish to discard them and add these items?';

export const CANCEL_ORDER = 'Cancel Order';
export const REFUNDED_TO = 'Refunded to';
export const PAID_VIA = 'Paid via';

export const NO_PAYMENT_METHOD_AVAILABLE = 'No Payment Method available';
export const NO_PAYMENT_METHOD_AVAILABLE_MESSAGE =
  'The selected application is not available on the device';

export const PAYTM_APP = 'paytm_app';

export const CANCELLATION_POLICY_NOTE = 'We have updated our cancellation policy!';
export const CANCEL_ORDER_TEXT = 'Are you sure you want to cancel the order?';
export const YES = 'Yes';
export const NO = 'No';

export const VIEW_ACCOUNT_DETAILS = 'View Account Details';

export const GUEST_ORDERING_APPROVAL_SERVICE = 'guest_ordering';

export const ORDER_DETAILS_NOT_FOUND =
  'We could not find this order. For assistance, please reach out to hello@hungerbox.com';

export const TRENDING = 'Trending';
export const TRENDING_IN_YOUR_CAFETERIA = 'Trending in your cafeteria';
export const RECOMMENDED = 'Recommended';

export const CONFIRM_ADDRESS_TEXT = 'Please make sure the delivery address is correct.';
export const NO_DELIVERY_FORMAT = 'Delivery is not enabled for selected cafeteria.';
